import React, { useEffect, useState } from 'react'
import CustomisedModal from '../../../components/Modal/CustomisedModal'
import ViewTable from '../../../components/Common/ViewTable'

export default function AchLogsModal({ openLogModal, setAchLogs, logs, totalRecords, achLogsRequest, hraMemberId, setHraMemberId }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const dispatchData = {
    achId: openLogModal,
    pagination: {
      limit: dataPerPage,
      page: currentPage,
      orderKey: "createdDate",
      orderBy: "ASC",
    },
  };
  useEffect(() => {
    achLogsRequest(dispatchData);
  }, [dataPerPage, currentPage]);

  const columns = [
    {
      dataField: "userId",
      text: "User",
      sort: true,
      formatter: (cell, row) => {
        return row.user ? row.user.fullName : row.hraMemberId;
      },
    },

    {
      dataField: "action",
      text: "Action",
      sort: true,
    },

    {
      dataField: "reason",
      text: "Reason for Action",
      sort: true,
    },
    {
      dataField: "createdAt",
      text: "Date and Time",
      sort: true,
    },
  ];

  return (
    <CustomisedModal
      modalView={openLogModal}
      customClass={
        "modal-lg "
      }
      bodyClass={"p-0 pb-3"}
      modalName={"ACH History - " + hraMemberId}
      onModalDismiss={() => {
        setAchLogs(false)
        setHraMemberId(null)
      }
      }
    >

      <ViewTable
        data={logs?.length > 0 ? logs : []}
        columns={columns}
        dataPerPage={dataPerPage}
        currentPage={currentPage}
        setDataPerPage={setDataPerPage}
        setCurrentPage={setCurrentPage}
        pagination={true}
        totalRecords={totalRecords}
        Header={true}
        updateData={() =>
          achLogsRequest({

            pagination: {
              limit: dataPerPage,
              page: 1,
              orderKey: "createdDate",
              orderBy: "ASC",
            },
          })
        }
      />
    </CustomisedModal>
  )
}
